module.exports = __webpack_public_path__ + "img/1alB-x-xuge'.65db17cd.jpg";